export const VUE_APP_HELPDESK_API_URL =
  process.env.VUE_APP_HELPDESK_API_URL || "https://helpdesk.mpk-dev.ru";
export const VUE_APP_CONS_FEEDBACK_URL =
  process.env.VUE_APP_CONS_FEEDBACK_URL || "https://consfeedback.mpk-dev.ru";
